export const environment = {
  production: false,
  appName: 'BiznesImot',
  appDomain: 'localhost',

  frontendUrl: 'https://bidev.pashov.dev',
  apiBaseUrl: 'https://bidev.pashov.dev/api',
  apiVersion: 'v1',

  maps: {
    provider: 'google',
    apiKey: '',
  },

  geoapifyApiKey: '288c93660a714da4b63cd1648262342c',
};
